import React from 'react';
import { useScreenInit } from './useScreenInit';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Founder } from './components/Founder';
import { WhySinclairs } from './components/WhySinclairs';
import { OurWork } from './components/OurWork';
import { Reviews } from './components/Reviews';
import { Accreditations } from './components/Accreditations';
import { FastPaths } from './components/FastPaths';
import { EngagementRings } from './components/EngagementRings';
import { Process } from './components/Process';
import { Comparison } from './components/Comparison';
import { Repairs } from './components/Repairs';
import { Diamonds } from './components/Diamonds';
import { LocalAuthority } from './components/LocalAuthority';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MobileStickyBar } from './components/MobileStickyBar';
export function App() {
  useScreenInit();
  return <div className="min-h-screen bg-background flex flex-col font-sans text-primary" data-id="element-0">
      <Header data-id="element-1" />

      <main className="flex-grow" data-id="element-2">
        {/* 1. Hero — emotional hook + named founder */}
        <Hero data-id="element-3" />

        {/* 2. Founder — the human face that solves "who can I trust?" */}
        <Founder data-id="element-4" />

        {/* 3. Why Sinclairs — trust stack, four substance pillars */}
        <WhySinclairs data-id="element-5" />

        {/* 4. Our Work — visual proof: real workshop, real Sinclairs pieces */}
        <OurWork data-id="element-6" />

        {/* 5. Reviews — third-party social proof, attributed via Google */}
        <Reviews data-id="element-7" />

        {/* 6. Accreditations — credentials & lifetime care promise */}
        <Accreditations data-id="element-8" />

        {/* 7. Fast Paths — the conversion router for all 6 personas */}
        <FastPaths data-id="element-9" />

        {/* 8. Engagement Rings — primary lead driver, with real price anchor */}
        <EngagementRings data-id="element-10" />

        {/* 9. Process — friction & uncertainty reducer */}
        <Process data-id="element-11" />

        {/* 10. Comparison — direct objection handling vs chain stores */}
        <Comparison data-id="element-12" />

        {/* 11. Repairs & Remodelling — secondary lead driver */}
        <Repairs data-id="element-13" />

        {/* 12. Diamonds — topical authority & high-intent commercial */}
        <Diamonds data-id="element-14" />

        {/* 13. Visit — local authority + map */}
        <LocalAuthority data-id="element-15" />

        {/* 14. FAQ — final objection sweep */}
        <FAQ data-id="element-16" />

        {/* 15. Final CTA — phone, visit & 2-step form */}
        <FinalCTA data-id="element-17" />
      </main>

      <Footer data-id="element-18" />
      <MobileStickyBar data-id="element-19" />
    </div>;
}